import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import api from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace('#', '?')).get('session_id');
    if (!sessionId) {
      navigate('/login');
      return;
    }

    (async () => {
      try {
        // URL-encode the session_id — Emergent returns a base64-like string
        // that can contain '=', '+' or '/' characters which would otherwise
        // corrupt the query string (seen intermittently on Chrome).
        const res = await api.get(`/auth/session?session_id=${encodeURIComponent(sessionId)}`);
        // Backend returns { token, user, ...user } so old clients keep working.
        // Persist the JWT on iPad/Safari/Chrome-with-3P-cookies-off where the
        // session_token cookie is often dropped.
        const token = res.data?.token || null;
        const userObj = res.data?.user || res.data;
        if (!userObj || !userObj.user_id) {
          throw new Error("Session exchange returned an incomplete user object");
        }
        login(userObj, token);
        // Give the auth context a tick to propagate the user before navigating
        // so PermissionsContext loads with the correct user on first render.
        setTimeout(() => {
          navigate('/dashboard', { replace: true, state: { user: userObj } });
        }, 0);
      } catch (err) {
        console.error('Auth callback error:', err, err.response?.data);
        navigate('/login', { replace: true, state: { error: err.response?.data?.detail || err.message || 'Sign-in failed' } });
      }
    })();
  }, [navigate, login]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
      <div className="text-center animate-fadeIn">
        <div className="w-8 h-8 border-2 border-rose-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-slate-600 font-['Manrope']">Signing you in...</p>
      </div>
    </div>
  );
}
